import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed } from '@angular/core';
import { environment } from 'src/environments/environment';
import { initialMarginRtoDatesSlice } from './margin-rto-dates.slice';
import { MarginRtoDate } from '../../models/margin-rto-date.model';

export const MarginRtoDatesStore = signalStore(
    { providedIn: 'root' },

    withState(initialMarginRtoDatesSlice),

    withComputed((store) => ({
        snapshot: computed(() => ({
            rtoDates: store.rtoDates()
        }))
    })),

    withMethods((store) => ({
        addRtoDate: (rtoDate: MarginRtoDate) => {
            const rtoDates = [...store.rtoDates(), rtoDate];
            patchState(store, { rtoDates });
        },

        updateRtoDatesFromData: (rtoDates: MarginRtoDate[]) => {
            patchState(store, { rtoDates });
        },

        clearRtoDates: () => {
            patchState(store, { rtoDates: [] });
        },

        getState: () => store,
        getSnapshot: () => store.snapshot()
    })),
    environment.storeWithDevTools('locums-margin-calculator-margin-rto-dates-store')
);
